import { render } from "./CreateCardView.vue?vue&type=template&id=4fc07737"
import script from "./CreateCardView.vue?vue&type=script&lang=js"
export * from "./CreateCardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__